import { render, staticRenderFns } from "./ContactEmergencyReport.vue?vue&type=template&id=31ed42b2&scoped=true"
import script from "./ContactEmergencyReport.vue?vue&type=script&lang=js"
export * from "./ContactEmergencyReport.vue?vue&type=script&lang=js"
import style0 from "./ContactEmergencyReport.vue?vue&type=style&index=0&id=31ed42b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed42b2",
  null
  
)

export default component.exports